<mbs-modal
  #modal
  [isCustomModal]="true"
  [title]="title">
  <div modal-body>
    @if (canAddStorageAccount && (isNBF || isSQLPlan) && ability.can('read', 'HelpMarketing')) {
      <ng-container>
        <mbs-alert
          class="mb-3"
          [icon]="true"
          [type]="mbsPopupType.info">
          {{ 'wizards:whereBackup.where_backup_need_new_storage' | i18next }}
          @if (createDestinationService && (hid || isRDMode)) {
            <mbs-button
              [isCtrl]="true"
              [loading]="creatingDestination"
              (click)="createDestination()">
              {{ 'shared:buttons.clickHere' | i18next }}
            </mbs-button>
          } @else {
            <a
              target="_blank"
              [href]="routingPath.ApStorages + '/addNew'">
              {{ 'shared:buttons.clickHere' | i18next }}
            </a>
          }
        </mbs-alert>
      </ng-container>
    }

    <mbs-where-backup-step-storage-list
      [disableRowTooltip]="disableRowTooltip"
      [maxHeight]="'500px'"
      [selectedStorages]="selectedStorages"
      [storages]="storages"
      (changeSelected)="changeSelectedHandler($event)"></mbs-where-backup-step-storage-list>
  </div>
  <ng-container modalFooter>
    <mbs-button
      class="ml-2"
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.close' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
